export default __webpack_public_path__ + "static/media/bw_photos_woodstock-3.f003ce71.jpg";